import aa from 'search-insights';
import config from './config';
import type {GeoHit} from 'instantsearch.js';
import type {Practice} from '../components/PracticesMapContainer';
import type {Key} from "react";

// Initialize Algolia Insights
aa('init', {
    appId: config.algolia_app_id,
    apiKey: config.algolia_search_api_key,
});

window.dataLayer = window.dataLayer || [];
/**
 * Track when a user clicks on a practice card
 */
export const trackPracticeClick = (practice: GeoHit<Practice>, eventName = 'Practice Card Clicked') => {
    window.dataLayer.push({
        event: 'quick_view--practice',
        position: practice.__position,
        ...getDataLayerPracticeObject(practice),
    })
    try {
        if (!practice.__queryID) {
            console.warn('Cannot track click: queryID is missing');
            return;
        }

        aa('clickedObjectIDsAfterSearch', {
            index: config.algolia_index_name,
            eventName,
            objectIDs: [practice.objectID],
            positions: [practice.__position],
            queryID: practice.__queryID,
        });


    } catch (error) {
        console.error('Failed to track practice click:', error);
    }
};

/**
 * Track when a user clicks "View Provider" button
 */
export const trackViewProviderClick = (practice: GeoHit<Practice>) => {
    try {
        window.dataLayer.push({
            event: 'clicked--practice',
            position: practice.__position,
            ...getDataLayerPracticeObject(practice),
        })

        if (!practice.__queryID) {
            console.warn('Cannot track view provider click: queryID is missing');
            return;
        }

        aa('clickedObjectIDsAfterSearch', {
            index: config.algolia_index_name,
            eventName: 'View Provider Clicked',
            objectIDs: [practice.objectID],
            positions: [practice.__position],
            queryID: practice.__queryID,
        });


    } catch (error) {
        console.error('Failed to track view provider click:', error);
    }
};

export const getDataLayerPracticeObject = (practice: GeoHit<Practice>) => {
    return {
        'practice_myevexias_id': practice.external_id,
        'practice_name': practice.name,
        'practice_nr_id': practice.id,
        'practice_city': practice.location.locality,
        'practice_state': practice.location.administrative_area_level_1,
        'practice_country': practice.location.country,
        'practice_postal_code': practice.location.postal_code,
        'page_type': 'Search Listing Page'
    }
}

/**
 * Track conversion when user interacts with contact information
 */
export const trackContactClick = (practice: GeoHit<Practice>, contactType: 'phone' | 'directions') => {

    switch (contactType) {
        case 'phone':
            window.dataLayer.push({
                event: 'phone_click--call_now--practice',
                ...getDataLayerPracticeObject(practice),
            })
            break;
        case 'directions':
            window.dataLayer.push({
                event: 'link_click--get_directions--practice',
                ...getDataLayerPracticeObject(practice),
            })
            break;
    }


    try {
        if (!practice.__queryID) {
            console.warn('Cannot track contact click: queryID is missing');
            return;
        }

        aa('convertedObjectIDsAfterSearch', {
            index: config.algolia_index_name,
            eventName: `Contact ${contactType === 'phone' ? 'Phone' : 'Directions'} Clicked`,
            objectIDs: [practice.objectID],
            queryID: practice.__queryID,
        });
    } catch (error) {
        console.error('Failed to track contact click:', error);
    }
};

export const trackQuizSubmission = (quizParams: {
    gender: string,
    assessment_level: string,
    assessment_score: Key,
    practice_name: string,
    practice_nr_id: Key
    practice_myevexias_id: Key
}) => {

    window.dataLayer.push(
        {
            event: 'custom_quiz_submitted',
            ...quizParams
        }
    )

}

export const trackContactProviderSubmission = (formParams: {
    practice_name: string,
    practice_nr_id: Key
    practice_myevexias_id?: Key
}) => {

    window.dataLayer.push(
        {
            event: 'contact_provider_submitted',
            ...formParams
        }
    )

}